import { Injectable } from '@angular/core'; 
import { User } from './objects/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  public login(userInfo: User){
    console.log ('trying to see login access_token')
    
    console.log (userInfo.role)
    localStorage.setItem('ACCESS_TOKEN', "access_token");
  }

  public isLoggedIn(){
    
    console.log ('Is the user logged in????')
    return localStorage.getItem('ACCESS_TOKEN') !== null;

  }

  public logout(){
    localStorage.removeItem('ACCESS_TOKEN');
  }
}